import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export default function useGiftCardVoidRefund({ csrfToken, onDone }) {
  const [giftCard, setGiftCard] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const openFor = (selectedGiftCard) => setGiftCard(selectedGiftCard);
  const close = () => setGiftCard(null);

  const submit = (choice, reason) => {
    const refunding = choice === 'refund';
    setSubmitting(true);
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    return axios.post(refunding ? giftCard.purchaseRefundUrl : giftCard.voidUrl, { reason })
      .then(() => {
        toast.success(refunding ? 'Gift card voided and refund started' : 'Gift card voided', { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
        if (onDone) onDone();
      })
      .catch((error) => {
        const data = error.response && error.response.data;
        const message = data && data.errors ? [].concat(data.errors).join(', ') : 'Could not update the gift card. Please try again.';
        toast.error(message, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
      })
      .then(() => setSubmitting(false));
  };

  return { giftCard, openFor, close, submitting, submit };
}
